<template>
  <q-form ref="editForm">
    <c-card title="멀티셀렉트 컴포넌트" height="700px" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-multi-select
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label="기본"
            name="col1"
            v-model="data.col1">
          </c-multi-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-multi-select
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label=""
            name="col1"
            v-model="data.col1">
          </c-multi-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-multi-select
            :required="true"
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label="필수값"
            name="col1"
            v-model="data.col1">
          </c-multi-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-multi-select
            :disabled="true"
            :editable="editable"
            :comboItems="comboItems"
            itemText="codeName"
            itemValue="code"
            label="disable"
            name="col1"
            v-model="data.col1">
          </c-multi-select>
        </div>
      </template>
    </c-card>
  </q-form>
</template>

<script>
export default {
  name: 'multiselect',
  data() {
    return {
      editable: true,
      data: {
        col1: [],
      },
      comboItems: [
        { code: '1', codeName: '서울/경기' },
        { code: '2', codeName: '경남' },
        { code: '3', codeName: '경북' },
        { code: '4', codeName: '제주도 및 그외' },
        { code: '5', codeName: '제주도 및 그외' },
        { code: '6', codeName: '제주도 및 그외' },
        { code: '7', codeName: '제주도 및 그외' },
        { code: '8', codeName: '제주도 및 그외' },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
  }
};
</script>
